import type { CSSProperties } from 'react';

import { TileGridTile } from './Tile/TileGridTile';
import {
  TileGridHolder,
  TileGridTileHolder,
  tileGridDesktopTilesPerRowVar,
} from './TileGrid.styled';
import type { TileGridTileData } from './TileGridTileData';
import type { TileGridVariant } from './TileGridVariant';

type Props = {
  id: string;
  tiles: TileGridTileData[];
  variant: TileGridVariant;
  tilesPerRow: 3 | 4;
  onClickTile: (index: number) => void;
};

export function TileGrid({
  id,
  tiles,
  variant,
  tilesPerRow,
  onClickTile,
}: Props) {
  return (
    <TileGridHolder
      id={id}
      style={{ [tileGridDesktopTilesPerRowVar]: tilesPerRow } as CSSProperties}
    >
      {tiles.map((tile, index) => (
        <TileGridTileHolder key={tile.id}>
          <TileGridTile
            id={tile.id}
            imageData={tile.imageData}
            variant={variant}
            heading={tile.heading}
            subHeading={tile.subHeading}
            description={tile.description}
            tileHref={tile.tileHref}
            onClick={() => onClickTile(index)}
          />
        </TileGridTileHolder>
      ))}
    </TileGridHolder>
  );
}
